// extracted by mini-css-extract-plugin
export var caption = "style-module--caption--38c1f";
export var carousel = "style-module--carousel--f29a0";
export var image = "style-module--image--9eb15";
export var item = "style-module--item--cfb17";